module.exports = __webpack_public_path__ + "img/or-menachem-ch.127eb41f.jpg";